export const IMG_SOURCE = 'https://ucarecdn.com/671d9593-af5e-44b0-aa99-1e4bf3065a99/logon.svg';
export const IMG_ALT = 'Lyon';
